function CultureProducer(props) {

    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">제작</h4>
                <h5 className="recruit_titleline_title">시사교양PD</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    프로그램마다 프로세스가 다르지만, 연출PD는 요즘 사람들이 무엇을 좋아하는지 혹은 무엇을 보고 싶어하는지를 찾아보고 서로 의견을 나누는 것에서부터 시작합니다.
                    다큐멘터리, 리얼리티 등 장르에 대한 선택을 포함한 프로그램 컨셉을 확정하고 제작비를 결정합니다.<br /><br />
                    작가, 카메라, 조명 등 다양한 전문가를 중심으로 팀을 구성하고, 이후 촬영, 녹화 준비과정부터 실제 촬영 및 촬영본 편집, 보정까지 팀원들에게 세부적인 행동지침을 내려주는 것이 주된 임무입니다.<br />
                    조연출PD는 pre-production 단계 보조를 포함해 예산 청구, 선급금 관리, 출연자 섭외, 제작시설 섭외, 촬영시간표 확정 등
                    제작 실무를 담당하고, 촬영 및 녹화 그리고 촬영본 편집(자막 디자인 결정 및 자막 내용 작성, BGM 선정, CG 디자인 의뢰 등)을 맡아 프로그램을 완성합니다.<br /><br />
                    시사교양PD 직무를 수행하기 위해서는 원활한 커뮤니케이션 능력이 필수적입니다.<br />
                    PD는 단순히 찍고 편집하는 사람이 아니라, 수많은 스텝, 출연자들과 의견을 조율하고 커뮤니케이션해야 하는 사람입니다.<br />
                    또한, 쉽지 않은 취재 과정을 돌파해낼 수 있는 끈기와 열정이 있으면 좋겠지요.<br />
                    마지막으로 의외로 빨리 돌아오는 방송주기에 맞춰 완성된 프로그램을 만들기 위해서는 강인한 정신력과 체력이 요구됩니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS는 전 국민이 아는 대표 시사교양 프로그램 &#60;그것이 알고 싶다&#62;를 비롯해 교양 프로그램의 새로운 지평을 열었다고
                    평가되는<br /> &#60;꼬리에 꼬리를 무는 그날 이야기&#62; 등 수많은 명품 프로그램을 만들어 내고 있습니다.<br />
                </p>
                <em className="recruit_bold_text">제작CP</em>
                <p className="recruit_subinfo_text">
                    TV는 물론 각종 OTT를 통해 전 세계의 시청자와 만나는 시사/다큐멘터리 프로그램, 교양 버라이어티, 생활문화/연예정보 프로그램,<br />특집 프로그램을 제작합니다.
                </p>
                <em className="recruit_bold_text">[주요 프로그램]</em>
                <p className="recruit_subinfo_text">
                    &#60;그것이 알고싶다&#62;<br />
                    &#60;꼬리에 꼬리를 무는 그날 이야기&#62;<br />
                    &#60;TV 동물농장&#62;<br />
                    &#60;SBS 스페셜&#62;<br />
                    &#60;궁금한 이야기 Y&#62;<br />
                    &#60;검은 양 게임&#62;<br />
                    &#60;당신이 혹하는 사이&#62;<br />
                </p>
                <em className="recruit_bold_text">사업</em>
                <p className="recruit_subinfo_text">
                    사업부서는 다시 디지털 사업을 전담하는 부서와 동물농장 관련 전담부서로 나뉩니다.<br />디지털 사업 전담부서는 유튜브 등 SNS 채널 운영이나
                    콘텐츠 제작 등 디지털 관련 사업을 모두 담당합니다.<br />동물농장 관련 전담부서는 동물 관련 프로그램을 기획, 제작하고, SNS 채널을 운영하며
                    관련 사업까지 모두 담당합니다.
                </p>
                <em className="recruit_bold_text">운영</em>
                <p className="recruit_subinfo_text">
                    예산을 편성하고 집행하며, 프로그램 제작 관련 계약체결도 운영파트의 업무입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    SBS는 시사/다큐멘터리, 교양 버라이어티, 생활문화 프로그램 등 모든 영역에서 타의 추종을 불허하는 강력한 IP를 보유하고 있습니다.<br />
                    SBS에 시사교양PD로 입사하면, 그런 프로그램들에서 기획부터 실행까지 PD로서 필요한 모든 것을 배우고, 주도적으로 업무를 수행할 수<br />있습니다.<br /><br />
                    여러 경험을 통해 본인이 강점을 가진 분야를 확인하고, 성실히 프로그램을 만들다 보면 어느덧 여러 선배 PD들과 같이 대한민국 사회에 <br />
                    건강한 영향력을 발휘할 수 있는 PD로 자리 잡을 수 있을 것입니다.<br />
                    선배들의 수많은 국내외 수상실적이 그 증거라고 할 수 있지요. 대표 시사교양PD를 꿈꾸는 많은 분들의 지원을 기다립니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    안녕하세요, 2016년에 입사한 손정민이라고 합니다.<br />
                    &#60;꼬리에 꼬리를 무는 그날 이야기&#62; 프로그램에서 연출을 하다가 현재는 기획팀으로 이동하여 새로운 프로그램을  고민하고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">시사교양PD가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    대학생 시절, 바로 이 글처럼 선배들이 작성한 글을 꼼꼼하게 읽으며 설렜던 기억이 납니다.
                    그때 시사교양PD가 어떤 일인지 설명하는 대목에서<br /> ‘당연하다고 여겨지는 고정관념에 질문을 던지는 일’이라는 글귀가 마음에 깊게 남았습니다.<br />
                    새로운 가능성을 향해 질문하고 싶다는 마음으로, 시사교양PD를 지원하게 되었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    좋은 이야기를 만들고 있다는 감각이 들 때 행복합니다.<br />
                    이야기가 넘치는 시대입니다. 그 홍수 속에서, 내 개성을 뽐내는 V-log를 찍기 보다는 타인의 마음에 관심을 두고,
                    좋은 메시지를 고민하는 것이 시사교양PD 입니다.
                    세상에 재미를 추구하는 일은 많지만, 어찌 보면 예스럽기도 순수하기도 한 기획의도를 품은 채 재미를 고민하고 있을 때 보람을 느낍니다.
                    더욱이 많은 사람에게 제 진심이 닿아 세상에 작은 변화가 일어나는 것을 보게 될 때는 정말 감사한 마음이 들기도 합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    분명 많은 고민 끝에 찾았을, 이 일이 하고 싶은 자신만의 이유를 잊지 않으면 좋겠습니다.<br />
                    어느 일이든 지치고 힘든 순간이 있는데, 그럴 때마다 나의 ‘이유’가 든든한 기둥이자 안락한 집이 되어줍니다.<br />
                    그리고 ‘재미’에 대한 진지한 자세가 필요합니다. 이게 왜 재미있지? 어떻게 하면 더 재미있을까?
                    이런 고민이 결국 PD의 주된 일이기<br />때문입니다. 이를 위해서라도, 자신만의 ‘재미’를 마음껏 느끼고 듬뿍 탐구해볼 것을 권합니다.
                </p>
            </div>

        </div>);
}

export default CultureProducer;

